import { httpClient } from "@/services";

export default {

	state: {
		equipmentListTrailer: [],
		equipmentFilterTrailer: null
	},
	mutations: {
		updateEquipmentListTrailer(state, { equipment, filter }) {
			state.equipmentListTrailer = equipment;
			state.equipmentFilterTrailer = filter;
		}
	},
	actions: {
		async onEquipmentListTrailer({ commit }, id) {
			try {
				const { data } = await httpClient.post(`/trailers/equipment/${ id }`);
				if (data && !data.status) {
					commit('updateEquipmentListTrailer', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onEquipmentListFilterTrailer({ commit }, { id, filters } ) {
			try {
				const { data } = await httpClient.post(`/trailers/equipment/${ id }/list`, filters);
				if (data && !data.status) {
					commit('updateEquipmentListTrailer', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onEquipmentCreateTrailer({ dispatch }, values) {
			const { id, trailerId, ...obj } = values;
			const url = id ? `trailers/equipment/${ id }/update` : `trailers/equipment/${ trailerId }/store`;
			const message = id ? "Updated equipment item" : "Created equipment item";
			const { data } = await httpClient.post(url, obj);

			if (data && data.status) {
				dispatch('setAlert', { type: "success", message });
				dispatch('onEquipmentListTrailer', trailerId);
			}
		},
		async onEquipmentSelectItemTrailer({ dispatch }, name) {
			const { data } = await httpClient.post('trucks/setEquipment', { name });
			if (data && !data.status) {
				dispatch('setAlert', { type: "success", message: "Created select item" });
				return data.equipments;
			}
		},
		async onEquipmentEditTrailer(context, id) {
			const { data } = await httpClient.get(`/trailers/equipment/${ id }/edit`);
			if (data && !data.status) {
				return data.equipment[0];
			}
		},
		async onEquipmentRemoveTrailer({ dispatch }, { id, trailerId }) {
			const { data } = await httpClient.delete(`/trailers/equipment/${ id }`);

			if (data && data.status) {
				dispatch('setAlert', { type: "success", message: "Remove equipment item" });
				dispatch('onEquipmentListTrailer', trailerId);
			}
		}
	},
	getters: {
		equipmentListTrailer: s => s.equipmentListTrailer,
		equipmentFilterTrailer: s => s.equipmentFilterTrailer,
	}
};
